<div *ngIf="isLoading" class="loader-class">
  <div>
    <img class="loader" src="assets/gif/loader.gif" alt="" />
  </div>
</div>
<router-outlet></router-outlet>
